import { ButtonPlus } from './ButtonPlus';

export { ButtonPlus } from './ButtonPlus';

export default ButtonPlus;
